"use strict";

var _taggedTemplateLiteral = require("/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  margin-left: 16px;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  margin-right: 16px;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  padding: 0 8px;\n  align-items: center;\n  justify-content: center;\n  display: flex;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  padding: 0 8px;\n  align-items: center;\n  justify-content: space-between;\n  display: flex;\n  width: 100%;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  width: auto;\n  height: 48px;\n  border: 0;\n  /* stylelint-disable-next-line altech-rdc/no-font-styles */\n  font-size: inherit;\n  cursor: pointer;\n  justify-content: center;\n  background: transparent;\n  &:disabled {\n    background: ", ";\n    path {\n      stroke: ", ";\n    }\n  }\n  -webkit-tap-highlight-color: transparent;\n  &:focus {\n    outline: none;\n  }\n  padding: 0;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(require("react"));

var styled_components_1 = __importDefault(require("styled-components"));

var ICON_ALIGNMENT;

(function (ICON_ALIGNMENT) {
  ICON_ALIGNMENT[ICON_ALIGNMENT["LEFT"] = 0] = "LEFT";
  ICON_ALIGNMENT[ICON_ALIGNMENT["RIGHT"] = 1] = "RIGHT";
})(ICON_ALIGNMENT = exports.ICON_ALIGNMENT || (exports.ICON_ALIGNMENT = {}));

var ButtonBase = styled_components_1.default.button(_templateObject(), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.disabled;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.disabled;
});

function Button(_a) {
  var icon = _a.icon,
      children = _a.children,
      _a$align = _a.align,
      align = _a$align === void 0 ? ICON_ALIGNMENT.RIGHT : _a$align,
      otherProps = __rest(_a, ["icon", "children", "align"]);

  if (icon && children) {
    return React.createElement(ButtonBase, Object.assign({}, otherProps), React.createElement(Wrapper, null, icon && align === ICON_ALIGNMENT.LEFT && React.createElement(LeftButtonIcon, null, icon()), children, icon && align === ICON_ALIGNMENT.RIGHT && React.createElement(RightButtonIcon, null, icon())));
  } else if (icon && !children) {
    return React.createElement(ButtonBase, Object.assign({}, otherProps), ' ', React.createElement(IconOnly, null, icon()));
  } else {
    return React.createElement(ButtonBase, Object.assign({}, otherProps), React.createElement(CenterWrapper, null, children));
  }
}

exports.Button = Button;
var Wrapper = styled_components_1.default.div(_templateObject2());
var CenterWrapper = styled_components_1.default.div(_templateObject3());
var LeftButtonIcon = styled_components_1.default.div(_templateObject4());
var RightButtonIcon = styled_components_1.default.div(_templateObject5());
var IconOnly = styled_components_1.default.div(_templateObject6());